import { X } from "lucide-react";
import { useState } from "react";
import { useRef } from "react";
import Image from "@/components/ui/image";
import { useMediaQuery } from "@mantine/hooks";
import { HoverBtn } from "@/components/styles";
import { lightenColor } from "@/utils/colorUtils";
import { WatermarkText } from "@/components/ui/text-styles";

export const Watermark: React.FC<{
  remove: any;
  hideControls?: boolean;
  color: string;
}> = ({ remove, hideControls, color }) => {
  const [isHovered, setIsHovered] = useState(false);
  const targetRef = useRef<HTMLDivElement | null>(null);

  const lighterColor = lightenColor(color, 10);
  const isMobile = useMediaQuery("(max-width: 768px)");

  return (
    <>
      <div
        style={{
          position: "absolute",
          bottom: "6px",
          right: "6px",
          zIndex: 99,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
        onMouseEnter={() => !isMobile && setIsHovered(true)}
        onMouseLeave={() => !isMobile && setIsHovered(false)}
        ref={targetRef}
      >
        {isHovered && (
          <>
            <div
              style={{
                position: "absolute",
                top: 0,
                right: 0,
                zIndex: 100,
              }}
            >
              <HoverBtn
                color={color}
                hoverColor={lighterColor}
                onClick={remove}
              >
                <X style={{ width: "12px", height: "12px" }} />
              </HoverBtn>
            </div>
          </>
        )}
        <div
          style={{
            width: "40px",
            height: "40px",
            position: "relative",
            opacity: 0.5,
          }}
        >
          <Image
            draggable={false}
            src={"/Mememaker/beraflip/beraflip_gs.png"}
            style={{
              objectFit: "contain",
            }}
            alt=""
            sizes="50vw"
            fill
          />
        </div>
        <WatermarkText style={{}}>Beraflip</WatermarkText>
      </div>
    </>
  );
};
